export const LESSON_TYPES = {
  liveLecture: 'live_lecture',
  assignment: 'assignment',
  homework: 'homework_assignment',
  preRead: 'pre_read',
  contest: 'contest',
};
